import { Filter, IFilters } from "constants/filters";
import { TicketsRoutes } from "constants/tickets/TicketsRoutes";
import { ticketFilters } from "constants/tickets/filters";
import { filtersToOmitInURLForRoute } from "helpers/tickets";
import { IAgent } from "store/entities/agents";
import { ITag } from "store/entities/tags";
import { ITeam } from "store/entities/teams";

// this object with typing is to make sure we don't omit any new filter in the order definition
const defaultFiltersOrderObject: { [key in Filter]: null } = {
  [Filter.Agent]: null,
  [Filter.AgentAssignment]: null,
  [Filter.CreationDateRange]: null,
  [Filter.LastActivityDateRange]: null,
  [Filter.LastMessageDateRange]: null,
  [Filter.DateRange]: null,
  [Filter.Group]: null,
  [Filter.Rating]: null,
  [Filter.Language]: null,
  [Filter.RatingDateRange]: null,
  [Filter.ResolutionDateRange]: null,
  [Filter.ResponseDateRange]: null,
  [Filter.ResponseAuthor]: null,
  [Filter.Tag]: null,
  [Filter.TicketStatus]: null,
  // @ts-expect-error TS(2339)
  [Filter.Date]: null,
  [Filter.RequesterEmail]: null,
  [Filter.Priority]: null,
  [Filter.Followers]: null,
  [Filter.DetailedSource]: null,
  [Filter.Attachments]: null,
  [Filter.Silo]: null,
  [Filter.Action]: null,
  [Filter.Author]: null,
  [Filter.Target]: null,
  [Filter.PageSize]: null,
  [Filter.NextId]: null,
  [Filter.PrevId]: null,
  [Filter.NextValue]: null,
  [Filter.PrevValue]: null,
  [Filter.DeliveryStatus]: null,
  [Filter.DeliveryUpdatedAtFrom]: null,
  [Filter.DeliveryUpdatedAtTo]: null,
};
export const defaultFiltersOrder = Object.keys(defaultFiltersOrderObject) as Filter[];

export interface ICustomViewFilterForDisplay {
  title: string;
  label: string;
  invalid: boolean;
}

export function getCustomViewFiltersForDisplay(
  filtersForCustomView: Partial<IFilters>,
  {
    agents,
    teams,
    tags,
    languageLabels,
  }: { agents: IAgent[]; teams: ITeam[]; tags: ITag[]; languageLabels: Record<string, string> },
  filtersOrder = defaultFiltersOrder,
  route = TicketsRoutes.All
): ICustomViewFilterForDisplay[] {
  const filterToItemsCollectionMap = {
    [Filter.Agent]: agents,
    [Filter.Followers]: agents,
    [Filter.Group]: teams,
    [Filter.Tag]: tags,
    [Filter.Language]: languageLabels,
  };

  const filtersToPutFirst = filtersToOmitInURLForRoute[route];
  const otherFilters = filtersOrder.filter(f => !filtersToOmitInURLForRoute[route].includes(f));

  // omit silo filter for displaying
  const finalOrder = [...filtersToPutFirst, ...otherFilters].filter(f => f !== Filter.Silo);

  return finalOrder
    .filter(filterName => !!filtersForCustomView[filterName])
    .map((filterName: Filter) => {
      const { config } = ticketFilters[filterName];
      const filterLabelValues = config.getFilterLabelValues(
        // @ts-expect-error TS(2345)
        filtersForCustomView[filterName],
        // @ts-expect-error TS(2345)
        filterToItemsCollectionMap[filterName]
      );

      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const containsInvalidValue = filterLabelValues.find((labelValue: any) => labelValue.invalid) !== undefined;
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const label = filterLabelValues.map((labelValue: any) => labelValue.label).join(", ");

      return {
        title: config.title,
        label,
        invalid: containsInvalidValue,
      };
    });
}
